@use '@design/design-tokens/typography/typography' as *;

.tooltipWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.rightWrapper {
  display: flex;
  flex-direction: column;
}

.bottomWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.recapWrapper {
  @include typography-v2-body-sm;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.recapValue {
  padding-right: 0.3em;
}

.recapLabel {
  color: var(--text-soft);
}

.valueWrapper {
  @include typography-v2-body-sm;
  font-family: var(--font-roboto-mono);
}

.descriptionLabel {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.titleLabel {
  @include typography-v2-title-sm;
}
